import React from "react";
import "../MathFormulaPrivacyPolicy.css";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

const MathFormulaPrivacyPolicy = () => {
  const navigate = useNavigate(); // hook to navigate programmatically

  const goHome = () => {
    navigate("/"); // navigate to homepage
  };

  return (
    <div className="privacy-policy-page">
      <SEO
        title="Privacy Policy - Math Formula - Let's Solve It | BlueOrbit Technologies"
        description="Privacy Policy for Math Formula - Let's Solve It app. Learn how we respect your privacy and keep your data safe."
        keywords="privacy policy, data protection, Math Formula app privacy, BlueOrbit Technologies privacy"
      />

      <header className="privacy-header">
        <div className="container">
          <nav className="nav">
            <div className="logo" onClick={goHome} style={{ cursor: "pointer" }}>
              <i className="fas fa-orbit"></i>
              <span>BlueOrbit Technologies</span>
            </div>
          </nav>
        </div>
      </header>

      <section className="privacy-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <ul className="breadcrumb">
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/">Apps</a>
            </li>
            <li>Privacy Policy</li>
          </ul>
        </div>
      </section>

      <section className="privacy-content">
        <div className="container">
          <div className="privacy-header">
            <h2>Privacy Policy for Math Formula - Let's Solve It</h2>
            <p className="effective-date">Effective Date: [25-09-2025]</p>
          </div>

          <div className="policy-content">
            <div className="policy-section">
              <h3>1. Information We Collect</h3>
              <p>
                We respect your privacy and do not collect any personal information. You can use all app features without sharing personal data.
              </p>
              <ul>
                <li>
                  <strong>Non-Personal Information:</strong> Only anonymous usage statistics may be collected to improve app performance, but no personal data is stored.
                </li>
                <li>
                  <strong>No Sensitive Data Access:</strong> We do not access contacts, messages, or any personal information from your device.
                </li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>2. App Features and Notifications</h3>
              <p>
                Our app provides math formulas, tricks, tables, quizzes, and gamified challenges. To enhance your experience, the app may request permission to send notifications for:
              </p>
              <ul>
                <li>New math tricks and formulas added to the app</li>
                <li>Quiz challenges and gamification updates</li>
                <li>Tips to improve learning and math practice</li>
              </ul>
              <p>
                Notifications are optional and can be disabled in your device settings. We do not use notifications for tracking or advertising purposes.
              </p>
            </div>

            <div className="policy-section">
              <h3>3. Data Security</h3>
              <p>
                No personal data is stored or transmitted. We take reasonable measures to maintain app security. Since we do not handle personal information, your data remains private and safe.
              </p>
            </div>

            <div className="policy-section">
              <h3>4. Third-Party Services</h3>
              <p>Our app may integrate third-party services for analytics or notifications:</p>
              <ul>
                <li>Analytics for anonymous usage tracking</li>
                <li>Notification services for timely app feature updates</li>
              </ul>
              <p>
                Third-party services have their own privacy policies. We recommend reviewing them separately.
              </p>
            </div>

            <div className="policy-section">
              <h3>5. Children's Privacy</h3>
              <p>
                Our app is not intended for children under 13 years old. We do not knowingly collect personal information from children.
              </p>
            </div>

            <div className="policy-section">
              <h3>6. Changes to This Privacy Policy</h3>
              <p>
                We may update this Privacy Policy from time to time. Updates will be posted here with the effective date. Please review this page periodically for changes.
              </p>
            </div>

            <div className="policy-section">
              <h3>7. Contact Us</h3>
              <p>
                If you have any questions or concerns about this Privacy Policy, please contact us at:
              </p>
              <p>
                Email: Blueorbittechnologies@gmail.com
              </p>
              <p>
                By using the Math Formula - Let's Solve It app, you agree to this Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="privacy-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>BlueOrbit Technologies</h3>
              <p>Creating innovative mobile solutions that enhance your learning experience.</p>
            </div>
            <div className="footer-section">
              <h3>Quick Links</h3>
              <ul>
                <li><a href="/">Home</a></li>
                <li><a href="/">Our Apps</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 BlueOrbit Technologies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MathFormulaPrivacyPolicy;
